
document.addEventListener("DOMContentLoaded", () => {
  const summaryElement = document.querySelector('#EventsPageEventBanner-container');
  const imagesElement = document.querySelector('#EventsPageEventDetails-Images');

  if (summaryElement && imagesElement) {
    const summaryHeight = summaryElement.offsetHeight;
    imagesElement.style.setProperty('--summary-height', `${summaryHeight}px`);
  }

  $(".leaflet-marker-icon").attr('alt', '');
});

$(document).ready(function () {
  // Check if 'start_rank' exists in the URL
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('start_rank')) {
    var anchor = $('#EventsPageFilters'); // Target the EventsPageFilters anchor by its ID

    if (anchor.length) {
      // Scroll to the anchor
      $('html, body').animate({
        scrollTop: anchor.offset().top
      }, 1000); // Adjust the duration as needed
    }
  }

  var isClearFilterTriggered = false;
  var falsePageNoClicked = 1;
  var initialFormState = getFormState();
  $('#filter-form').on('submit', function (e) {
    e.preventDefault();

    var what = $('#filter-what').html().replace(/<br\s*\/?>/gi, '').trim();
    if (what.indexOf('All events') !== -1) {
      what = 'ALL';
    }
    var when = $('input[name="filterWhen"]:checked').val();
    var keyword = $('#keyword-filter').val();
    var falsePageTotal = $('#falsePage2').length;

    var data = '';
    if (falsePageTotal == 0) {
      data = { filterWhat: what, filterWhen: when, filterKeyword: keyword };
    } else {
      data = { filterWhat: what, filterWhen: when, filterKeyword: keyword, falsePage: 'true', FalsePageNoClicked: falsePageNoClicked };
    }

    // Hide EventsPageGrid and show EventsPageLoading before AJAX request
    $('#EventsPagePagination').fadeOut();
    $('#EventsPageGrid').fadeOut('slow');

    $.ajax({
      url: getSiteLocationPath() + "/filter",
      type: 'POST',
      data: data,
      success: function (response) {
        $('#EventsFilterPagination').html(response);
        $('#EventsPageGrid').fadeIn('slow', function () {
          $('.event-card').fadeIn('slow');
          $('#EventsPagePagination').fadeIn('slow');
        });
        initialFormState = getFormState(); // Update initial state after successful submission
      },
      error: function (xhr, status, error) {
        console.error('AJAX request failed:', status, error);
        $('#EventsFilterPagination').html('');
      }
    });
  });

  function getSiteLocationPath() {
    var pathArray = window.location.pathname.split("/");
    var newPathname = "";
    for (i = 0; i < pathArray.length; i++) {
      if (pathArray[i].length) {
        newPathname += "/";
        newPathname += pathArray[i];
        if (pathArray[i] === "whats-on") {
          break;
        }
      }
    }

    return window.location.origin + newPathname;
  }

  function getFormState() {
    return {
      what: $('#filter-what').text(),
      when: $('input[name="filterWhen"]:checked').val(),
      keyword: $('#keyword-filter').val()
    };
  }

  function hasFormChanged() {
    var currentState = getFormState();
    return initialFormState.what !== currentState.what ||
      initialFormState.when !== currentState.when ||
      initialFormState.keyword !== currentState.keyword;
  }

  $(document).on('click', '#events-spell-search', function (e) {
    var spellSuggestion = $(this).text();
    $('#keyword-filter').val(spellSuggestion);
    if ($('#filter-form').length > 0) {
      $('#filter-form').submit();
    } else {
      $('#programfilter-form').submit();
    }
  });

  $(document).on('click', '#events-filter-clear', function (e) {
    isClearFilterTriggered = true;
    $('#filter-what').text('All events');
    $('input[name="event-type"]').prop('checked', false); // Uncheck all event-type
    $('#events-all').prop('checked', true);
    $('#filter-when').text('Anytime');
    $('#filterWhen1').prop('checked', true);
    $('#keyword-filter').val('');
    $('.filter-container-autocomplete').removeClass('filter-container-autocomplete-has-value'); // Remove the class
    if ($('#filter-form').length > 0) {
      $('#filter-form').submit();
    } else {
      $('#programfilter-form').submit();
    }
    isClearFilterTriggered = false;
  });

  // Observe changes to all .filter-container elements
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (!isClearFilterTriggered && $('.filter-container-active').length == 0 && !$(mutation.target).find('.filter-with-dropdown:after').length) {
        if (hasFormChanged()) {
          if ($('#filter-form').length > 0) {
            $('#filter-form').submit();
          } else {
            $('#programfilter-form').submit();
          }
        }
      }
    });
  });

  document.querySelectorAll('.filter-container').forEach(function (container) {
    observer.observe(container, { attributes: true, attributeFilter: ['class'] });
  });

  $(document).on('click', '#clear-filter-btn', function (e) {
    $('#keyword-filter').val(''); // Reset keyword-filter
    $('.filter-container-autocomplete').removeClass('filter-container-autocomplete-has-value'); // Remove the class
    if ($('#filter-form').length > 0) {
      $('#filter-form').submit();
    } else {
      $('#programfilter-form').submit();
    }
  });

  $(document).on('click', '#falsePage2', handleNextFalsePageClick);

  $(document).on('click', '#falseNext', handleNextFalsePageClick);

  $(document).on('click', '#falsePage1', handlePrevFalsePageClick);

  $(document).on('click', '#falsePrev', handlePrevFalsePageClick);


  function handleNextFalsePageClick() {
    if (!$(this).hasClass('active')) {
      falsePageNoClicked = "2";
      $('#filter-form').submit();
    }
  }

  function handlePrevFalsePageClick() {
    if (!$(this).hasClass('active')) {
      falsePageNoClicked = "1";
      $('#filter-form').submit();
    }
  }

  /* Update top banner background color */
  var bannerElement = $('#EventsPageEvent-breadcrumb');
  if (bannerElement.length) {
    var backgroundColor = bannerElement.css('background-color');
    if (backgroundColor) {
      $('#header').css('background-color', backgroundColor);
    }
  }


  /* program filter */
  $('#programfilter-form').on('submit', function (e) {
    e.preventDefault();

    var what = $('#filter-what').text();
    if (what.indexOf('All events') !== -1) {
      what = 'ALL';
    }
    var when = $('input[name="filterWhen"]:checked').val();
    var keyword = $('#keyword-filter').val();
    var brandID = $('#brandID').val();

    var data = { tag: what, dFilter: when, TitleSearch: keyword, brandID: brandID };

    // Hide EventsPageGrid and show EventsPageLoading before AJAX request
    $('#EventsProgramPagePagination').fadeOut();
    $('#EventsProgramPageGrid').fadeOut('slow');

    $.ajax({
      url: getSiteLocationPath() + "/programmefilter",
      type: 'POST',
      data: data,
      success: function (response) {
        $('#BrandEventsGridPagination').html(response);
        // Check if .events-norecords exists in #BrandEventsGridPagination
        if ($('#BrandEventsGridPagination .events-norecords').length > 0) {
          // Find all <strong> elements and remove <br> tags inside them
          $('#BrandEventsGridPagination .events-norecords strong').each(function () {
            $(this).find('br').remove();
          });
        }
        $('#EventsProgramPageGrid').fadeIn('slow', function () {
          $('.event-card').fadeIn('slow');
          $('#EventsProgramPagePagination').fadeIn('slow');
        });
        initialFormState = getFormState(); // Update initial state after successful submission
      },
      error: function (xhr, status, error) {
        console.error('AJAX request failed:', status, error);
        $('#BrandEventsGridPagination').html('');
      }
    });
  });
});